import Button from "components/common/buttons/buttons";
import { TYPO } from "styles/Typo";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import moment from "moment";
import { TrackedLink } from "lib/analytics/react/link";

function BriefingFloating({
  date,
  adVisible,
}: {
  date: string;
  adVisible: boolean;
}) {
  const router = useRouter();
  const { t } = useTranslation("main");
  const dateLabel =
    router.locale === "ko"
      ? moment(date).format("M월 D일")
      : moment(date).format("MMM D");
  return (
    <div
      className="fixed bottom-[20px] left-[50%] translate-x-[-50%] z-[10] bg-white rounded-[41px] border border-gray15 flex gap-3 px-3 py-2 items-center"
      style={{
        boxShadow: "0px 0px 8px 0px rgba(0, 0, 0, 0.08)",
        bottom: adVisible ? "-60px" : "20px",
        transition: "bottom 0.3s ease-in-out",
      }}
    >
      <p
        className={`${TYPO.TYPO7_1_MD} text-gray80 whitespace-nowrap shrink-0`}
      >
        {t("briefingLabel", { date: dateLabel })}
      </p>
      <TrackedLink
        href="/briefing"
        asTrace={true}
        itemspec={{
          kind: "section_nav",
          section_id: "feed_briefing",
          nav_key: "feed_navbtn_go_briefing_floating",
        }}
      >
        <Button
          type="secondary"
          size="sm"
          text={t("goView")}
          btnClass="shrink-0 !bg-gray90 !text-white !rounded-[38px]"
          dataGtmId="briefing-floating-button"
        />
      </TrackedLink>
    </div>
  );
}

export default BriefingFloating;
